import { InterfaceComponentOptions } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/elements/factory-options.interface';
import { ILogic } from './logic.interface';
import {
    IBaseComponent,
} from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/components/base-component/base-component.interface';

export class ComponentLogic implements ILogic {
    protected readonly componentOptions: InterfaceComponentOptions;
    protected readonly component: IBaseComponent;

    public constructor(componentOptions: InterfaceComponentOptions, component: IBaseComponent) {
        this.componentOptions = componentOptions;
        this.component = component;
    }

    public init(): void {
        // 初始化
    }

    public dispose(): void {
        // 释放资源
    }
}
